import { useState } from 'react';

/** The state every token form shares: it was submitted (errors show), the API's problem, per-field API errors and busy. */
export function useSubmitState() {
  const [submitted, setSubmitted] = useState(false);
  const [problem, setProblem] = useState<unknown>(null);
  const [server, setServer] = useState<Record<string, string>>({});
  const [busy, setBusy] = useState(false);
  return { submitted, setSubmitted, problem, setProblem, server, setServer, busy, setBusy };
}

export type SubmitState = ReturnType<typeof useSubmitState>;
